<svg style="width: 100%; height: 100%; max-width: 24px; max-height: 24px;">
    <use href="/img/patreon_icon.svg"></use>
</svg>
